import React, { useEffect} from "react";
import { useMsal} from "@azure/msal-react";
import { useNavigate } from "react-router-dom";

const REDIRECT_PAGE = "/mails"; // Path to the home page | CAN BE CHANGED
const LOGIN_PAGE = "/login"; // Path to the login page | CAN BE CHANGED


/**
 * Home component, the main page of the application
 * 
 * 
 * @returns {JSX.Element} Home component
 */
function Home() {
    const {instance} = useMsal();
    const navigate = useNavigate();


    useEffect(() => {   
        if(instance.getActiveAccount() !== null) {
            navigate(REDIRECT_PAGE);
            return;
        }

        const account = instance.getAllAccounts()[0];
        if (account) {
            instance.setActiveAccount(account);
            navigate(REDIRECT_PAGE);
        } else {
            navigate(LOGIN_PAGE);
        }
        
    }, [ navigate, instance]);
    return (
        <div>
            <h1>Redirection en cours...</h1>
            <p>Merci de patienter.</p>
        </div>
    );
}

export default Home;